import { connect, MapStateToProps } from 'react-redux'
import { Props } from './ComparisonPdfButton'
import comparisonCarlineResultDataSelector
    from '../../../redux/selectors/comparison/comparisonCarlineResultDataSelector'
import comparisonDataSelector from '../../../redux/selectors/comparison/comparisonDataSelector'

type StateProps = Pick<
    Props,
    | 'resultData'
    | 'comparisonData'
>

const mapStateToProps: MapStateToProps<StateProps, Omit<Props, keyof StateProps>> = (state): StateProps => ({
    resultData: comparisonCarlineResultDataSelector(state),
    comparisonData: comparisonDataSelector(state),
})

export default connect(mapStateToProps)
